import { Box } from '@mui/material';
import { type IDateAttribute } from '../../../Interfaces/ILegalTransactionMeasure';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const DateAttribute = ({
  attribute,
  onUpdateAttribute,
}: {
  attribute: IDateAttribute;
  onUpdateAttribute: (attribute: IDateAttribute) => void;
}) => {
  return (
    <Box>
      <DatePicker
        sx={{ minWidth: '300px', backgroundColor: 'background.paper' }}
        slotProps={{
          textField: {
            size: 'small',
            required: attribute.Required,
            fullWidth: true,
          },
        }}
        label={attribute.Name}
        value={attribute.Value ? new Date(attribute.Value) : null}
        onChange={newValue => {
          onUpdateAttribute({
            ...attribute,
            Value: newValue?.toISOString().split('T')[0] || undefined,
          });
        }}
      />
    </Box>
  );
};
